import {defineStore} from 'pinia'
import AxiosService from '../../services/app/axiosService';
import authHeader from '../../services/app/authHeader';

const name = 'userMenu'

export const useUserMenuStore = defineStore(name, {
  state: () => ({
    userMenu: [],
    permissions: {}
  }),

  actions: {
    async loadAuthorizedMenu() {
      const response = await AxiosService.get('/profile/loadAuthorizedMenu', { headers: authHeader() });
      this.userMenu = response.data;
      this.permissions = this.createPermissionsMap(response.data);
    },

    createPermissionsMap(menu) {
      const permissions = {};
      const processNode = (node) => {
        permissions[node.key] = node.authorized
      }
      menu.forEach(processNode);
      return permissions;
    },

    hasPermission(key) {
      let permission = this.permissions[key] ?? false;
      return permission
    },
  },

});
